/* eslint-disable no-debugger */
import { distributorService } from '../../service/distributor.service';
import 'react-toastify/dist/ReactToastify.css';
import { getConstants, ProductConstants,OrderConstants } from './actionType';

function DistributorList(page, searchValue, filterValue) {
    function request(user) { return { type: getConstants.GET_DISTRIBUTORS_LIST_REQUEST, user }; }
    function success(user) { return { type: getConstants.GET_DISTRIBUTORS_LIST_SUCCESS, user }; }
    function failure(error) {
        return { type: getConstants.GET_DISTRIBUTORS_LIST_FAILURE, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await distributorService.DistributorList(page, searchValue, filterValue);
        if (data.error) {
            dispatch(failure(data.message));
            return data;
        } 
        dispatch(success(data));
        return data;
    };
}
function updateAdminUser(body, email) {
    function request(user) { return { type: getConstants.GET_PARTICULAR_REQUEST, user }; }
    function success(user) { return { type: getConstants.GET_PARTICULAR_SUCCESS, user }; }
    function failure(error) {
        return { type: getConstants.GET_PARTICULAR_FAILURE, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await distributorService.updateAdminUser(body, email);
        if (data.error) {
            dispatch(failure(data.message));
        }
        dispatch(success(data));
        return data;
    };
}
function SortDistributor(body) {
    function request(user) { return { type: getConstants.GET_PARTICULAR_REQUEST, user }; }
    function success(user) { return { type: getConstants.GET_PARTICULAR_SUCCESS, user }; }

    return async (dispatch) => {
        dispatch(request());
        dispatch(success(body));
        return body;
    };
}
function AdminPaginationMethod(data, type) {
    function add(user) { return { type: getConstants.ADD_PAGINATION, user }; }
    function remove(user) { return { type: getConstants.REMOVE_PAGINATION, user }; }

    return async (dispatch) => {
        if (type === 'add') {
            dispatch(add(data));
        } else {
            dispatch(remove(data));
        }
        return data;
    };
}
// GET PROFILE
function GetprofileData() {
    function request(user) { return { type: getConstants.PROFILE_REQUEST, user }; }
    function success(user) { return { type: getConstants.PROFILE_SUCCESS, user }; }
    function failure(error) {
        return { type: getConstants.PROFILE_FAILURE, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await distributorService.Getprofile();
        if (data.error) {
            dispatch(failure(data.message));
            return data;
        }
        dispatch(success(data));
        return data;
    };
}
//Product Listing
function ProductListing(payload,filters) {
    function request(user) { return { type: ProductConstants.GET_PRODUCTS_LIST_REQUEST, user }; }
    function success(user) { return { type: ProductConstants.GET_PRODUCTS_LIST_SUCCESS, user }; }
    function failure(error) {
        return { type: ProductConstants.GET_PRODUCTS_LIST_FAILURE, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await distributorService.GetProductList(payload);
        if (data.error) {
            dispatch(failure(data.message));
            return data;
        } 
        dispatch(success(data));
        return data;
    };
}
function GetWishlist(payload,key) {
    function request(user) { return { type: ProductConstants.GET_WISHLIST_LIST_REQUEST, user }; }
    function success(user) { return { type: ProductConstants.GET_WISHLIST_LIST_SUCCESS, user }; }
    function failure(error) {
        return { type: ProductConstants.GET_WISHLIST_LIST_FAILURE, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await distributorService.ListwhishList(payload);
        if (data.error) {
            dispatch(failure(data.message));
            return data;
        } 
        dispatch(success(data));
      
        return data;
    };
}
function handleFiltersData(filter) {
    function success(user) { return { type: ProductConstants.GET_PRODUCTS_FILTERS_SUCCESS, user }; }
    
    return async (dispatch) => {
        dispatch(success(filter));
        return filter;
    };
}

function GetCartItems(key,key2) {
    function request(user) { return { type: ProductConstants.GET_CART_LIST_REQUEST, user }; }
    function success(user) { return { type: ProductConstants.GET_CART_LIST_SUCCESS, user }; }
    function failure(error) {
        return { type: ProductConstants.GET_CART_LIST_FAILURE, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await distributorService.CartItems(key,key2);
        if (data.error) {
            dispatch(failure(data.message));
            return data;
        } 
        dispatch(success(data));
      
        return data;
    };
}
function GetCartCalculation(payload,key) {
    function request(user) { return { type: ProductConstants.CART_CALCULATION_REQUEST, user }; }
    function success(user) { return { type: ProductConstants.CART_CALCULATION_SUCCESS, user }; }
    function failure(error) {
        return { type: ProductConstants.CART_CALCULATION_FAILURE, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await distributorService.CartCalculation();
        if (data.error) {
            dispatch(failure(data.message));
            return data;
        } 
        dispatch(success(data));
      
        return data;
    };
}
function GetOfferDetails(id) {
    function request(user) { return { type: ProductConstants.OFFER_DETAILS_REQUEST, user }; }
    function success(user) {
        const temp = [];
        let obj={...user?.data?.data}
        user?.data?.data.product_criterion.map((val,i)=>{
            val['id']=`${user?.data?.data.composit_key}-${i}`    
            temp.push(val)
        })
        obj.product_criterion=temp
        return { type: ProductConstants.OFFER_DETAILS_SUCCESS, obj };
    }
    function failure(error) {
        return { type: ProductConstants.OFFER_DETAILS_FAILURE, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await distributorService.GetOfferDetails(id);
        if (data.error) {
            dispatch(failure(data.message));
            return data;
        } 
        dispatch(success(data));
      
        return data;
    };
}

function GetBulkOfferDetails(id) {
    function request(user) { return { type: ProductConstants.BULK_OFFER_DETAILS_REQUEST, user }; }
    function success(user) {
        const temp = [];
        let obj={...user?.data?.data}
        user?.data?.data.product_criterion.map((val,i)=>{
            val['id']=`${user?.data?.data.composit_key}-${i}`    
            temp.push(val)
        })
        obj.product_criterion=temp
        return { type: ProductConstants.BULK_OFFER_DETAILS_SUCCESS, obj };
    }
    function failure(error) {
        return { type: ProductConstants.BULK_OFFER_DETAILS_FAILURE, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await distributorService.GetBulkOfferDetails(id);
        if (data.error) {
            dispatch(failure(data.message));
            return data;
        } 
        dispatch(success(data));
      
        return data;
    };
}



function GetOfferData(data,product,orderValue) {
    function success(user,product) { return { type: ProductConstants.OFFER_DATA_SUCCESS, user,product,orderValue }; }
    return async (dispatch) => {
        dispatch(success(data,product,orderValue));
        return data;
    };
}
function GetOrderDetails(id) {
    function request(user) { return { type: OrderConstants.GET_ORDER_DETAILS_REQUEST, user }; }
    function success(user) { return { type: OrderConstants.GET_ORDER_DETAILS_SUCCESS, user }; }
    function failure(error) {
        return { type: OrderConstants.GET_ORDER_DETAILS_FAILURE, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await distributorService.ViewOrderDetails(id);
        if (data.error) {
            dispatch(failure(data.message));
            return data;
        } 
        dispatch(success(data));
      
        return data;
    };
}
export const DistributorActions = {
    DistributorList,
    updateAdminUser,
    SortDistributor,
    AdminPaginationMethod,
    GetprofileData,
    ProductListing,
    handleFiltersData,
    GetWishlist,
    // handleSelected,
    GetCartItems,
    GetCartCalculation,
    GetOfferDetails,
    GetOfferData,
    GetOrderDetails,
    GetBulkOfferDetails,

};